import React from "react";
import ModalContainer from "../common/ModalContainer";

function OdiopayInfoModal({ open, setOpen }) {
  const data = [
    {
      title: "1. Interest Rates & Fees",
      detail: [
        {
          type: "paragraph",
          content:
            "A flat rate of 3.5% for a maximum period of 30 days is charged after a minimum of 50% of the ticket cost is paid.",
        },
        {
          type: "paragraph",
          content:
            "Tickets that are not fully paid beyond the stipulated time will get a grace period. The duration of which will depend on the refund validity date. This situation will attract another 3.5% fee. Failure to redeem will initiate the refund process and after fees and penalties are paid all outstanding fees to Odiopay will be deducted before balance is returned to client.",
        },
      ],
    },
    {
      title: "2. Availability, commencement and target market",
      detail: [
        {
          type: "paragraph",
          content:
            "The service shall be offered to individual customers through their ticketing agents on the Intraverse platform. No ads, only by targeted communication.",
        },
        {
          type: "paragraph",
          content:
            "The Service shall commence with only 5 slots in each month. Once filled, the service is fully subscribed until the next month. This will serve as a control to avoid oversubscription and allow a gradual scaling of the float funds available to deliver the service.",
        },
      ],
    },
    {
      title: "3. How it works",
      detail: [
        {
          type: "list",
          content: [
            "Make bookings on Intraverse and choose audio pay check out.",
            "Make the 50% of total cost down payment.",
            "Choose an approved payment plan for the balance over a specified period.",
            "On payment of the initial deposit ticket is locked in, PNR issued but remains unavailable for use until all instalments are paid.",
          ],
        },
      ],
    },
    {
      title: "4. Features",
      detail: [
        {
          type: "paragraph",
          content:
            "Refunds are not available except on deposits after all penalties are deducted.",
        },
      ],
    },
    {
      title: "5. Internal requirements",
      detail: [
        {
          type: "paragraph",
          content: "An Odiopay dashboard showing live transactions.",
        },
      ],
    },
  ];
  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      padding="px-4 py-6"
      title={"Odiopay ticket price lock service"}
    >
      <div className="w-full flex flex-col">
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 w-full rounded-md">
              <div className="w-full flex flex-col gap-2">
                {data?.map((item, itemIndex) => (
                  <div className="flex w-full flex-col gap-3" key={itemIndex}>
                    <span className="font-bold">{item.title}</span>
                    <div className="w-full flex flex-col">
                      {item.detail.map((detail, detailIndex) => {
                        switch (detail.type) {
                          case "list":
                            return (
                              <div key={detailIndex}>
                                <ul className="list-disc w-full ml-8">
                                  {detail?.content?.map(
                                    (listItem, listItemIndex) => (
                                      <li key={listItemIndex} className="">
                                        {listItem}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            );
                          default:
                            return (
                              <div key={detailIndex}>{detail?.content}</div>
                            );
                        }
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default OdiopayInfoModal;
